<template>
  <div class="direction">
    <TopBar />
    <h2>Direcção</h2>

    <div v-for="level in hierarchy" :key="level.title" class="level-section">
      <h3 class="level-title">{{ level.title }}</h3>
      <div class="members">
        <div v-for="member in level.members" :key="member.name" class="member" :class="level.class">
          <img :src="member.photo" :alt="member.name" />
          <div>
            <h4>{{ member.name }}</h4>
            <p class="role">{{ member.role }}</p>
            <p class="rank">{{ member.rank }}</p>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import TopBar from '../components/TopBar.vue';
import Footer from '../components/Footer.vue';

import joaoSilva from '@/assets/members/joao_silva.jpg';
import mariaCosta from '@/assets/members/maria_costa.jpg';
import pedroLopes from '@/assets/members/pedro_lopes.jpg';
import anaFerreira from '@/assets/members/ana_ferreira.jpg';
import carlosMendes from '@/assets/members/carlos_mendes.jpg';
import teresaOliveira from '@/assets/members/teresa_oliveira.jpg';
import ricardoSantos from '@/assets/members/ricardo_santos.jpg';
import miguelRodrigues from '@/assets/members/miguel_rodrigues.jpg';
import sofiaPereira from '@/assets/members/sofia_pereira.jpg';
import hugoMartins from '@/assets/members/hugo_martins.jpg';
import inesAlmeida from '@/assets/members/ines_almeida.jpg';
import tiagoSousa from '@/assets/members/tiago_sousa.jpg';
import beatrizNunes from '@/assets/members/beatriz_nunes.jpg';
import andreGomes from '@/assets/members/andre_gomes.jpg';

export default {
  name: 'Direction',
  components: { TopBar, Footer },
  data() {
    return {
      hierarchy: [
        {
          title: 'Presidência',
          class: 'level-1',
          members: [
            { name: 'Mestre João Silva', role: 'Presidente', rank: '7º Dan', photo: joaoSilva },
            { name: 'Mestre Maria Costa', role: 'Vice-Presidente', rank: '6º Dan', photo: mariaCosta },
          ],
        },
        {
          title: 'Diretores',
          class: 'level-2',
          members: [
            { name: 'Sensei Pedro Lopes', role: 'Diretor Técnico', rank: '5º Dan', photo: pedroLopes },
            { name: 'Sensei Ana Ferreira', role: 'Diretora de Competição', rank: '5º Dan', photo: anaFerreira },
            { name: 'Sensei Carlos Mendes', role: 'Diretor de Formação', rank: '4º Dan', photo: carlosMendes },
            { name: 'Sensei Teresa Oliveira', role: 'Diretora Administrativa', rank: '4º Dan', photo: teresaOliveira },
          ],
        },
        {
          title: 'Coordenadores e Instrutores',
          class: 'level-3',
          members: [
            { name: 'Sensei Ricardo Santos', role: 'Coordenador Zona Sul', rank: '3º Dan', photo: ricardoSantos },
            { name: 'Sensei Miguel Rodrigues', role: 'Coordenador Zona Norte', rank: '3º Dan', photo: miguelRodrigues },
            { name: 'Sensei Sofia Pereira', role: 'Coordenadora Zona Centro', rank: '3º Dan', photo: sofiaPereira },
            { name: 'Sensei Hugo Martins', role: 'Instrutor Principal', rank: '2º Dan', photo: hugoMartins },
            { name: 'Sensei Inês Almeida', role: 'Instrutora de Kata', rank: '2º Dan', photo: inesAlmeida },
            { name: 'Sensei Tiago Sousa', role: 'Instrutor de Kumite', rank: '2º Dan', photo: tiagoSousa },
            { name: 'Sensei Beatriz Nunes', role: 'Instrutora Juvenil', rank: '1º Dan', photo: beatrizNunes },
            { name: 'Sensei André Gomes', role: 'Instrutor de Iniciação', rank: '1º Dan', photo: andreGomes },
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
.direction {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.level-section {
  width: 100%;
  padding: 2rem 1rem;
  text-align: center;
}
.level-title {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
  border-bottom: 2px solid #e53935;
  display: inline-block;
  padding-bottom: 0.3rem;
}
.members {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 0.5rem;
}
.member {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  padding: 1.2rem;
  text-align: center;
}
.member img {
  border-radius: 50%;
}
.member h4 {
  margin: 0.5rem 0 0.2rem;
  font-size: 1rem;
}
.role {
  color: #e53935;
  font-weight: bold;
  margin: 0.2rem 0;
  font-size: 0.9rem;
}
.rank {
  color: #666;
  margin: 0;
  font-size: 0.85rem;
}

/* Level 1 - Presidência: larger cards */
.level-1 {
  min-width: 220px;
  max-width: 300px;
  border-top: 4px solid #e53935;
}
.level-1 img {
  width: 140px;
  height: 140px;
}

/* Level 2 - Diretores: medium cards */
.level-2 {
  min-width: 180px;
  max-width: 260px;
  border-top: 3px solid #ff7043;
}
.level-2 img {
  width: 120px;
  height: 120px;
}

/* Level 3 - Coordenadores/Instrutores: smaller cards */
.level-3 {
  min-width: 150px;
  max-width: 220px;
  border-top: 2px solid #999;
}
.level-3 img {
  width: 100px;
  height: 100px;
}

@media (max-width: 768px) {
  .members {
    gap: 1rem;
  }
  .level-1 img {
    width: 110px;
    height: 110px;
  }
  .level-2 img {
    width: 100px;
    height: 100px;
  }
  .level-3 img {
    width: 80px;
    height: 80px;
  }
}

@media (max-width: 480px) {
  .level-section {
    padding: 1.5rem 0.5rem;
  }
  .level-title {
    font-size: 1.2rem;
  }
  .members {
    gap: 0.8rem;
  }
  .member {
    padding: 0.8rem;
    width: calc(50% - 0.5rem);
    min-width: 0;
    max-width: none;
  }
  .level-1 img {
    width: 90px;
    height: 90px;
  }
  .level-2 img {
    width: 80px;
    height: 80px;
  }
  .level-3 img {
    width: 70px;
    height: 70px;
  }
  .member h4 {
    font-size: 0.85rem;
  }
  .role, .rank {
    font-size: 0.8rem;
  }
}
</style>

